import CryptoJS from "crypto-js";
import { fetchAndCacheCSEKKey, getCachedCSEKKey } from "./secured-nexus-bridge";

// const base64Key = await getCachedCSEKKey()

export const encryptData = async (data) => {
  // Wait for the CSEK key to be available
  let csek_key = await getCachedCSEKKey();
  if (!csek_key) {
    csek_key = await fetchAndCacheCSEKKey();
  }
  if (!csek_key) {
    throw new Error("CSEK key not available");
  }

  // Parse the key as a CryptoJS WordArray
  const key = CryptoJS.enc.Base64.parse(csek_key);

  // Convert JSON data to string
  const dataStr = JSON.stringify(data);

  // Generate a random 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt using AES-CBC
  const encrypted = CryptoJS.AES.encrypt(dataStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Convert encrypted data and IV to Base64
  const ciphertext = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivBase64 = iv.toString(CryptoJS.enc.Base64);

  return { ciphertext, iv: ivBase64 };
};

export const decryptData = async (encryptedData) => {
  if (!encryptedData.ciphertext) return encryptedData;

  let csek_key = await getCachedCSEKKey();
  if (!csek_key) {
    csek_key = await fetchAndCacheCSEKKey();
  }
  if (!csek_key) {
    throw new Error("CSEK key not available");
  }

  // Parse the key for CryptoJS
  const key = CryptoJS.enc.Base64.parse(csek_key);
  const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedData.ciphertext);

  // Decrypt using AES-CBC
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedStr);
};